<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :btn_cancel="true"
    :centered="true"
    :title="title"
    :size="'md'"
  >
    <CRow v-if="action == 'QR'">
      <CCol sm="12" class="text-ceter">
        <CInput
          type="text"
          v-model="wsp.name"
          label="Nombre de instancia"
          disabled
        >
        </CInput>
        <CInput
          type="text"
          v-model="wsp.conected"
          label="Esatado de instancia"
          disabled
          placeholder="Digite nombre de instancia"
        >
        </CInput>
      </CCol>
      <CCol sm="12">
        <label>{{ seconds }} segundos restantes</label>
      </CCol>
      <CCol sm="12" class="text-center">
        <img :src="imageBase64" alt="qr" />
      </CCol>
    </CRow>
    <CRow v-else>
      <CCol sm="12" class="text-ceter">
        <CInput
          type="text"
          v-model="wsp.name"
          label="Nombre de instancia"
          disabled
        >
        </CInput>
        <CInput
          type="text"
          v-model="wsp.conected"
          label="Esatado de instancia"
          disabled
          placeholder="Digite nombre de instancia"
        >
        </CInput>
      </CCol>
    </CRow>
    <template #footer>
      <button @click="mtdClose" class="btn btn-danger btn-sm">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </button>
      <button
        v-if="action != 'ACTIVE'"
        class="btn btn-success btn-sm"
        @click="mtdCommitSend"
      >
        <i class="fas fa-save"></i>
        {{ action == "create" ? "Crear instancia" : "QR escaneado" }}
      </button>
    </template>
  </CModal>
</template>

<script>
import CModal from "../../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";

export default {
  components: { CModal },
  data() {
    return {
      swall: null,
      action: "",
      wsp: {
        id: "",
        name: "",
        instance_id: "",
        conected: "",
        state: "",
      },
      imageBase64: null,
      /** expired */
      seconds: 60,
      isRunning: false,
      timer: null,
    };
  },
  created() {},
  watch: {
    item(newItem) {
      this.castVaribles();
    },
  },
  props: {
    title: String,
    boo_modal: Boolean,
    id_company: Number,
    item: Object,
    token: String
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.$emit("mtdCloseModalWsp", this.action);
      this.action = "";
    },
    castVaribles: function () {
      if (this.item.instance_id == "") {
        this.wsp.id = this.item.Id; //id de compañia
        this.wsp.name = "";
        this.wsp.instance_id = this.item.instance_id;
        this.action = "create";
      } else {
        this.mtdGetInfoInstance();
      }
    },
    mtdCommitSend: function () {
      if (this.action == "create") {
        this.post({
          url: this.$store.getters.get__url + "/instancewsp/" + this.action,
          token: this.$store.getters.get__token,
          params: this.wsp,
        }).then((response) => {
          Swal.fire("¡Completado!", response.message, "success");
          this.mtdClose();
        });
      } else if (this.action == "QR") {
        this.mtdClose();
      }
    },
    mtdGetInfoInstance: function () {
      if (this.item.phone_connected == false) {
        this.post({
          url: this.$store.getters.get__url + "/instancewsp/qr",
          token: this.$store.getters.get__token,
          params: {
            token: this.token
          },
        }).then((response) => {
          this.wsp.name = this.item.user.name;
          this.wsp.conected =
            this.item.phone_connected == true ? "CONECTADO" : "DESCONECTADO";
          const img = response.data.qrBase64;
          this.imageBase64 = this.item.phone_connected == false ? img : null;
          this.action = "QR";
          this.mtdStartCountdown();
        });
      } else {
        this.wsp.name = this.item.user.name;
        this.wsp.conected =
          this.item.phone_connected == true ? "CONECTADO" : "DESCONECTADO";
        const img = null;
        this.imageBase64 = null;
        this.action = "ACTIVE";
      }
    },
    mtdStartCountdown() {
      if (this.isRunning) return;
      this.isRunning = true;
      this.seconds = 60;

      this.timer = setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--;
        } else {
          clearInterval(this.timer);
          this.isRunning = false;
        }
      }, 1000);
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>